import { cacheRequest } from '@/base/MaRequestPooler.js'

/**
 * Returns all taxonomies
 * @returns {Promise<*>} List of taxonomy.
 */
export function fetchAllTaxonomies() {
  return cacheRequest(`/match/taxonomies`)
}
